import { PageLayout } from "components/designV2/layout/pageLayout";
import { ScheduleOptionsPanel } from "./components/optionsPanel/scheduleOptionsPanel.component";
import { ScheduleToolbar } from "./components/toolbar/scheduleToolbar.component";
import { ScheduleMonthView } from "./components/views/month/scheduleMonthView.component";
import { ScheduleWeekView } from "./components/views/week/scheduleWeekView.component";
import { ShiftDetailsModal } from "./components/common/modals/shiftDetailsModal.component";
import { TeamPublicDetailsModal } from "./components/common/modals/teamPublicDetailsModal/teamPublicDetailsModal.component";
import { NotAvailableShiftModal } from "./components/common/modals/notAvailableShiftModal.component";
import { QuickScheduleModal } from "./components/common/modals/quickScheduleModal.component";
import { ErrorModal } from "web-apps/company/components/common/errorModal.component";
import { GigFormModal } from "web-apps/company/components/gig/gigForm/modal/gigFormModal.component";
import { ScheduleStatus } from "model/Schedule";
import { useState } from "react";
import { useScheduleViewModel } from "./schedule.logic";

export const Schedule = (): JSX.Element => {
  const viewModel = useScheduleViewModel();
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);

  return (
    <PageLayout>
      <ScheduleToolbar
        {...viewModel.toolbarProps}
        onOptionsClick={() => setIsOptionsOpen(true)}
      />
      <ScheduleOptionsPanel
        isOpen={isOptionsOpen}
        intervalOption={viewModel.toolbarProps.intervalOption}
        groupByOption={viewModel.toolbarProps.groupByOption}
        sizeOption={viewModel.toolbarProps.sizeOption}
        onGroupByChange={viewModel.toolbarProps.onGroupByChange}
        onSizeChange={viewModel.toolbarProps.onSizeChange}
        onClose={() => setIsOptionsOpen(false)}
      />
      {viewModel.intervalOption === "weekly" ? (
        <ScheduleWeekView {...viewModel.weeklyViewProps} />
      ) : (
        <ScheduleMonthView {...viewModel.monthlyViewProps} />
      )}
      {viewModel.selectedShift &&
        viewModel.resolvedStatus &&
        (viewModel.resolvedStatus === ScheduleStatus.NOT_AVAILABLE ? (
          <NotAvailableShiftModal
            isOpen
            onClose={viewModel.handleCloseModal}
            worker={viewModel.selectedShift.worker}
            section={viewModel.selectedShift.section}
            shift={viewModel.selectedShift.item}
          />
        ) : viewModel.selectedShift.modalTarget === "teamPublicDetails" ? (
          <TeamPublicDetailsModal
            isOpen
            onClose={viewModel.handleCloseModal}
            worker={viewModel.selectedShift.worker}
            selectedShift={viewModel.selectedShift.item}
            status={viewModel.resolvedStatus}
          />
        ) : (
          <ShiftDetailsModal
            isOpen
            onClose={viewModel.handleCloseModal}
            worker={viewModel.selectedShift.worker}
            gigRole={viewModel.selectedShift.worker.text2}
            selectedShift={viewModel.selectedShift.item}
            section={viewModel.selectedShift.section}
            shiftDetails={viewModel.shiftDetails}
            isShiftDetailsLoading={viewModel.isShiftDetailsLoading}
            shiftDetailsError={viewModel.shiftDetailsError}
            status={viewModel.resolvedStatus}
            onShiftEdited={viewModel.handleShiftEdited}
            onAbsenceReported={viewModel.refreshShiftStatus}
            onWithdrawCompleted={viewModel.refreshShiftStatus}
            onReplaceSuccess={viewModel.handleReplaceSuccess}
          />
        ))}
      <ErrorModal
        isOpen={viewModel.isReplaceSuccessOpen}
        onClose={viewModel.closeReplaceSuccessModal}
        titleKey="Schedule.ReplaceSuccessLabel"
        messageKey="Schedule.ReplaceSuccess"
      />
      <GigFormModal
        showGigFormModal={viewModel.isGigFormOpen}
        setShowGigFormModal={viewModel.setGigFormOpen}
        onCreated={viewModel.handleGigCreated}
      />
      <QuickScheduleModal
        isOpen={Boolean(viewModel.quickSchedulePayload)}
        payload={viewModel.quickSchedulePayload}
        onClose={viewModel.closeQuickScheduleModal}
        onCreated={viewModel.handleQuickScheduleCreated}
      />
    </PageLayout>
  );
};
